import Access from './access.svg';
import AccountVerified from './account-verified.svg';
import AdvanceSuccess from './advance-success.svg';
import Congratulations from './congratulations.svg';
import Contact from './contact.svg';
import ContactUs from './contact-us.svg';
import DocumentUpdated from './document-updated.svg';
import KycSuccess from './kyc-success.svg';
import Login from './login.svg';
import LoginScreen from './login-screen.svg';
import MeetAdvance from './meet-advance.svg';
import NoInternet from './no-internet.svg';
import ResetPasswordSuccess from './reset-password-success.svg';
import ResetPassword from './reset-password.svg';
import ResetPin from './reset-pin.svg';
import SalaryOnDemand from './salary-on-demand.svg';
import SendSuccess from './send-success.svg';
import SubmittedSelfOnboarding from './submitted-self-onboarding.svg';
import Success from './success.svg';
import SuccessfulSignUp from './successful-sign-up.svg';
import Uploading from './uploading.svg';
import VerifyingEmail from './verifying-email.svg';
import Waiting from './waiting.svg';
import Warning from './warning.svg';
import Error400 from './error-400.svg';
import Error401 from './error-401.svg';
import Error403 from './error-403.svg';
import Error404 from './error-404.svg';
import Error500 from './error-500.svg';
import Error502 from './error-502.svg';
import Error503 from './error-503.svg';
import Error504 from './error-504.svg';
import ErrorNetwork from './error-network.svg';
import ErrorSessionTimeout from './error-session-timeout.svg';
import Maintenance from './maintenance.svg';
import MaintenanceCebuana from './maintenance-cebuana.svg';
const illustrations = {
  Access,
  AccountVerified,
  AdvanceSuccess,
  Congratulations,
  Contact,
  ContactUs,
  DocumentUpdated,
  KycSuccess,
  Login,
  LoginScreen,
  MeetAdvance,
  NoInternet,
  ResetPasswordSuccess,
  ResetPassword,
  ResetPin,
  SalaryOnDemand,
  SendSuccess,
  SubmittedSelfOnboarding,
  Success,
  SuccessfulSignUp,
  Uploading,
  Waiting,
  VerifyingEmail,
  Warning,
  Error400,
  Error401,
  Error403,
  Error404,
  Error500,
  Error502,
  Error503,
  Error504,
  ErrorNetwork,
  ErrorSessionTimeout,
  Maintenance,
  MaintenanceCebuana
};
export default illustrations;
//# sourceMappingURL=index.js.map